/* eslint-disable */
import { generateId } from "@/utils/"

const buildBaseComponentsLibrary = () => {
	const baseComponents = [
		{ component: "JBox", attrsMap: {}, label: "Box", children: [], tags: ["layout"] },
		{ component: "JFlex", attrsMap: { class: "flex" }, label: "Flex", children: [], tags: ["layout"] },
		{
			component: "JText",
			attrsMap: { class: "leading-relaxed text-c3" },
			content:
				"Lorem ipsum dolor sit amet, consectetur adipiscing elit. Suspendisse gravida vestibulum ipsum euismod vestibulum. Class aptent taciti sociosqu ad litora torquent per conubia nostra, per inceptos himenaeos. Proin pellentesque, sapien et accumsan blandit, tortor velit faucibus felis, aliquet pretium turpis ante non nisi. Morbi fermentum tellus eu semper finibus.",
			label: "Text",
			children: [],
			tags: ["text"]
		},
		{
			component: "JHeadline",
			attrsMap: { class: "text-4xl text-cBlack" },
			content: "Headline here",
			label: "Headline",
			children: [],
			tags: ["text"]
		},
		{
			component: "JLabel",
			attrsMap: { class: "mb-1 font-bold" },
			content: "Label",
			label: "Label",
			children: [],
			tags: ["text"]
		},

		{
			component: "JInputText",
			attrsMap: {},
			label: "Text Input",
			editorSettings: {
				props: [{ name: "v-model", label: "Data Binding", handler: "JInputText", description: "Select data field" }]
			},
			tags: ["form"]
		},
		{
			component: "JInputLongText",
			attrsMap: {},
			label: "Long Text Input",
			editorSettings: {
				props: [{ name: "v-model", label: "Data Binding", handler: "JInputText", description: "Select data field" }]
			},
			tags: ["form"]
		},
		{
			component: "JInputNumber",
			attrsMap: {},
			label: "Number Input",
			editorSettings: {
				props: [{ name: "v-model", label: "Data Binding", handler: "JInputText", description: "Select data field" }]
			},
			tags: ["form"]
		},
		{
			component: "JInputNumberStepper",
			attrsMap: {},
			label: "Number Stepper",
			editorSettings: {
				props: [{ name: "v-model", label: "Data Binding", handler: "JInputText", description: "Select data field" }]
			},
			tags: ["form"]
		},
		{
			component: "JSlider",
			attrsMap: {},
			label: "Slider",
			editorSettings: {
				props: [{ name: "v-model", label: "Data Binding", handler: "JInputText", description: "Select data field" }]
			},
			tags: ["form"]
		},
		{
			component: "JToggle",
			attrsMap: {},
			label: "Toggle",
			editorSettings: {
				props: [{ name: "v-model", label: "Data Binding", handler: "JInputText", description: "Select data field" }]
			},
			tags: ["form"]
		},
		{
			component: "JCheckbox",
			attrsMap: {},
			label: "Checkbox",
			editorSettings: {
				props: [{ name: "v-model", label: "Data Binding", handler: "JInputText", description: "Select data field" }]
			},
			tags: ["form"]
		},
		{
			component: "JCheckboxGroup",
			// NOTE: dynamic props are passed as strings because when they are compiled, they are compiled as strings
			attrsMap: {
				":options": "[{ name: 'Option 1', value: 'option_1' },{ name: 'Option 2', value: 'option_2' }]"
			},
			editorSettings: {
				props: [{ name: "v-model", label: "Data Binding", handler: "JInputText", description: "Select data field" }]
			},
			label: "Checkbox Group",
			tags: ["form"]
		},
		{
			component: "JRadios",
			attrsMap: { ":options": "[{ name: 'Option 1', value: 'option_1' },{ name: 'Option 2', value: 'option_2' }]" },
			label: "Radio Group",
			editorSettings: {
				props: [{ name: "v-model", label: "Data Binding", handler: "JInputText", description: "Select data field" }]
			},
			tags: ["form"]
		},
		{
			component: "JSelect",
			attrsMap: { ":options": "[{ name: 'Option 1', value: 'option_1' },{ name: 'Option 2', value: 'option_2' }]" },
			label: "Select",
			editorSettings: {
				props: [{ name: "v-model", label: "Data Binding", handler: "JInputText", description: "Select data field" }]
			},
			tags: ["form"]
		},
		{
			component: "JMultiSelect",
			attrsMap: { ":options": "[{ name: 'Option 1', value: 'option_1' },{ name: 'Option 2', value: 'option_2' }]" },
			label: "Multi Select",
			editorSettings: {
				props: [{ name: "v-model", label: "Data Binding", handler: "JInputText", description: "Select data field" }]
			},
			tags: ["form"]
		},

		{
			component: "JInputDateOfBirth",
			attrsMap: {},
			label: "Date Of Birth",
			editorSettings: {
				props: [{ name: "v-model", label: "Data Binding", handler: "JInputText", description: "Select data field" }]
			},
			tags: ["form"]
		},
		{ component: "JDatePicker", attrsMap: {}, label: "Date Picker", tags: ["form"] },
		{ component: "JSpinner", attrsMap: {}, label: "Loading Spinner", tags: ["form"] },
		{ component: "JHtmlRenderer", attrsMap: {}, label: "Html", tags: ["text"] },
		{ component: "JButton", attrsMap: {}, label: "Button", content: "Click me!", children: [], tags: ["form"] }
	]

	const output = baseComponents.map(baseComponent => {
		return {
			id: generateId(),
			attrsMap: {},
			...baseComponent
		}
	})

	return output
}

export { buildBaseComponentsLibrary }
